export const UUID_NIL = '00000000-0000-0000-0000-000000000000';
